/**
 * goToChannelsLineup action.
 */
import Channel from '../../classes/channel';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

interface Props {
  channel?: Channel;
  stacked?: boolean;
}

/**
 * Function to redirect to the channel lineup page.
 */
export default function goToChannelsLineup(props?: Props) {
  if (props) {
    const { channel, stacked } = props;
    store.dispatch(
      pushRoute({
        route: { Page: Pages.CHANNELS_LINEUP, overwrite: !stacked },
        params: {
          current: {
            channel,
            stacked,
          },
        },
      })
    );
  } else {
    store.dispatch(
      pushRoute({
        route: { Page: Pages.CHANNELS_LINEUP },
        params: { current: { stacked: true }, push: true },
      })
    );
  }
}
